import * as autobind from 'autobind';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'redux-scaffolding-ts';
import { QueryResult } from '../../stores/dataStore';
import { CustomizationDataDto, CustomizationDataStore } from '../../stores/configuration/events-n-requests/customization-data-store';
import { SelectionInput } from '../form/selectionInput';
import { nameof } from '../../utils/object';
import { ItemReference } from '../../stores/dataStore';
import { isNullOrWhiteSpaces } from '../../utils/useful-functions';

interface CustomizationDataEditorProps extends WithTranslation {
  value: ItemReference;
  onChange: (value: ItemReference) => void;
  className?: string;
  placeholder?: string;
  customizationDatas?: CustomizationDataStore;
  nullable?: boolean;
  minWidth?: number;
  reloadOnChange?: boolean;
  clearable?: boolean;
  readOnly?: boolean;
}

interface CustomizationDataEditorState {
  value: ItemReference;
  query?: (searchQuery: string) => Promise<QueryResult<ItemReference>>;
}

@connect(['customizationDatas', CustomizationDataStore])
class CustomizationDataEditor extends React.Component<CustomizationDataEditorProps, CustomizationDataEditorState> {
  private get customiaztionDatasStore() {
    return this.props.customizationDatas;
  }

  constructor(props: CustomizationDataEditorProps) {
    super(props);
    this.state = {
      value: this.props.value,
      query: this.getCustomizationDataMethod()
    };
  }

  UNSAFE_componentWillReceiveProps(next) {
    if (next !== this.props && next.value !== this.props.value && this.props.reloadOnChange) {
      this.setState({
        value: next.value,
        query: this.getCustomizationDataMethod()
      });
    }
  }

  @autobind
  private getCustomizationDataMethod() {
    const method = async (search: string) => {
      const result = await this.customiaztionDatasStore.getAllAsync({
        searchQuery: '',
        skip: 0,
        take: 100000,
        orderBy: [{ direction: 'Ascending', field: nameof<CustomizationDataDto>('name'), useProfile: false }],
        filter: isNullOrWhiteSpaces(search)
          ? []
          : [`startswith(tolower(${nameof<CustomizationDataDto>('name')}), '${search.toLowerCase()}')`]
      });
      return Object.assign({}, result, { items: result.items.map(c => ({ id: c.id, title: c.name })) }) as QueryResult<ItemReference>;
    };
    return method;
  }

  public render() {
    const val = this.state.value;
    const query = this.state.query;
    return (
      <SelectionInput
        readOnly={this.props.readOnly}
        content={item => <div>{item.title}</div>}
        searchable
        className={this.props.className}
        minWidth={this.props.minWidth}
        nullable={this.props.nullable}
        placeholder={this.props.placeholder}
        query={query}
        value={val}
        onChange={value => this.props.onChange(value as any)}
        clearable={this.props.clearable}
      />
    );
  }
}

// Wire up the React component to the Redux store
export default withTranslation()(CustomizationDataEditor);
